/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div id='home-bg'>
    <!--canvas背景-->
    <Background></Background>
    <!--头部-->
    <Header :groupInfo="groupInfo" :logo="logo" @changeLogo="changeLogo" :projectList="projectList" :current="projectInfo.id" @clickItem="clickItem"></Header>
    <!--项目信息-->
    <ProjectInfo :projectInfo="projectInfo"></ProjectInfo>
    <!--概览-->
    <Overview :overview="craneOverview" ></Overview>
    <!--风险报警详情-->
    <StatRiskDetail :behaviorHighDetail="behaviorHighDetail" :behaviorLowDetail="behaviorLowDetail" :bodyRiskDetail="bodyRiskDetail"/>
    <!--风险统计-->
    <StatisticsToday :data="staticsInfo"></StatisticsToday>
    <!--高危风险、低危风险、机体风险-->
    <RealRiskDetail :bodyRiskList="bodyRiskList" :behaviorHighList="behaviorHighList" :behaviorLowList="behaviorLowList"></RealRiskDetail>
    <!--结构数据-->
    <CraneInformation :data="craneObj"></CraneInformation>
    <!--添加摄像头-->
    <Camera @showVideoDiv = 'showVideoDiv' :data="clickVideoObj"></Camera>
    <!--3D塔机-->
    <ThreeDQunCraneTwo :screenChange="isScreenChange" :cranes="cranes" :config="areaConfig" :runData = 'runData' @getClickCrane = 'getClickCrane' @initFinish="callRequest"></ThreeDQunCraneTwo>
    <!--展示视频-->
    <Video class="drag" v-drag v-if="showVideo && isEZOpen" :addr="videoAddr" :videoTitle='videoTitle' :ysToken="ysToken" :craneName="craneName" @closeVideoDiv = 'closeVideoDiv' @reGetToken="reGetToken"></Video>
    <HLSVideo class="drag" v-drag v-if="showVideo && !isEZOpen" :addr="videoAddr" :videoTitle='videoTitle' :craneName="craneName" @closeVideoDiv = 'closeVideoDiv'></HLSVideo>
    <!--知识产权-->
    <Bottom v-if="logo === 'sada'"/>
  </div>
</template>

<script>
import $ from 'jquery'
import dayjs from 'dayjs'
import Background from '@/components/Background'
import Header from '@/components/Header'
import ProjectInfo from '@/components/ProjectInfo'
import Overview from '@/components/Overview'
import StatRiskDetail from '@/components/StatRiskDetail'
import StatisticsToday from '@/components/StatisticsToday'
import RealRiskDetail from '@/components/RealRiskDetail'
import CraneInformation from '@/components/CraneInformation'
import ThreeDQunCraneTwo from '@/components/ThreeDQunCraneTwo'
import Bottom from '@/components/Bottom'
import Video from '@/components/Video'
import HLSVideo from '@/components/HLSVideo'
import Camera from '@/components/Camera'
import {
  getGroupProjectInfo,
  getProjectInfo,
  getOnlineRate,
  getYSToken,
  getProCraneStruct,
  getProVideoList,
  getSpreadStaticData,
  getSpreadRealData,
  getShareToken,
  getOperationMonitorHomeStat,
  getListRiskRank,
  getBehavioralRiskDetail,
  getBodyRiskDetail
} from '@/api/metric'
const formatter = 'YYYY-MM-DD'

const today = dayjs().format(formatter)
export default {
  name: 'home',
  data () {
    return {
      clickIndex: 0,
      logo: 'sada', // 公司主体，用于更换图标
      loopTimer: null, // 实时数据轮询
      craneTimer: null, // 塔机定时轮询
      riskStatTimer: null, // 统计的轮询
      riskDetailsTimer: null, // 详情的轮询
      shareTokenTimer: null, // 分享token的轮询
      shareTokenParams: {}, // 分享token的参数
      showVideo: false,
      videoAddr: null, // 视频专用
      craneName: '', // 视频专用
      videoTitle: '', // 视频专用
      ysToken: null,
      craneObj: {
        id: null,
        projectCraneNum: '', // 塔机名称
        realityCraneHeight: 0, // 塔高
        craneType: 0, // 塔机类型
        realityJibArmLength: 0, // 起重臂长
        balanceArmLength: 0, // 平衡臂长
        factoryName: '', // 厂商
        craneModel: '', // 类型
        ratedLiftingTorque: 0, // 额定起重力矩
        ratedLoad: 0, // 额定吊重
      }, // 当前点击的塔机
      behaviorHighList: [], // 高危行为风险
      behaviorLowList: [], // 低危行为风险
      bodyRiskList: [], // 机体风险
      behaviorHighDetail: [], // 高危行为风险详情
      behaviorLowDetail: [], // 低危行为风险详情
      bodyRiskDetail: [], // 机体风险详情
      clickVideoObj: [],
      groupInfo:{name: null},
      projectInfo: {
        id: null,
        deviceIds: [],
        name: null,
        status: 0,
        address: null,
        safetyOfficer: null,
        safetyOfficerMobile: null,
        safetyDirector: null,
        safetyDirectorMobile: null,
        constructionCompanyName: null
      },
      craneOverview: {
        craneTotal: 0,
        online: 0
      },
      staticsInfo: {
        bodyRiskTotal: 0,
        sceneRiskTotal: 0,
        behaviorRiskTotal: 0,
        hostingRiskTotal: 0,
        illegalRiskTotal: 0
      },
      craneStructData: {}, // 塔机结构参数数据
      craneVideoData: {}, // 塔机视频数据
      cranes: [],
      oldRunDataObj: {},
      currentRunDataObj: {},
      runData: [],
      areaConfig: {},
      isScreenChange: Math.random(),
      projectList: [], // 组合项目
      dataViewConfig: {}, // 组合项目的配置
      deviceIds: []
    }
  },
  components: {
    Background,
    Header,
    ProjectInfo,
    Overview,
    StatRiskDetail,
    StatisticsToday,
    RealRiskDetail,
    CraneInformation,
    ThreeDQunCraneTwo,
    Video,
    HLSVideo,
    Camera,
    Bottom
  },
  computed: {
    isEZOpen () {
      return this.videoAddr && this.videoAddr.startsWith('ezopen')
    }
  },
  methods: {
    // 更改公司名称
    changeLogo () {
      this.logo = 'sada'
    },
    // 点击项目切换
    clickItem (projectId) {
      this.getProject(projectId)
    },
    getClickCrane (craneId) {
      this.clearCraneTimer()
      this.timerClickRequest()
      this.craneObj = this.craneStructData[craneId]
      this.clickIndex = Object.keys(this.craneStructData).indexOf(craneId)
      if (!this.showVideo) {
        this.clickVideoObj = this.craneVideoData[craneId] || []
      }
    },
    closeVideoDiv () {
      this.showVideo = false
    },
    showVideoDiv (item) {
      if (item) {
        this.showVideo = true
        const {projectCraneNum, installationSiteName, videoAddress} = item
        this.craneName = projectCraneNum
        this.videoTitle = installationSiteName
        this.videoAddr = videoAddress
      }
    },
    // 获取组合大屏的配置
    getGroupDataVConfig (projectGroupId) {
      getGroupProjectInfo(projectGroupId).then(async res => {
        const {data, success} = res
        if (success) {
          try {
            const {groupName, projectList, dataViewConfig} = data
            const parseConfig = JSON.parse(dataViewConfig)
            const {rect} = parseConfig
            if (!!projectList.length) {
              const firstProjectId = projectList[0].ouId
              this.getProject(firstProjectId)
              this.projectList = projectList
              this.dataViewConfig = parseConfig
              this.groupInfo = {name: groupName}
              this.areaConfig = rect
              const allStructRequest = []
              const allVideoListRequest = []
              const allSpreadStaticRequest = []
              projectList.forEach((item) => {
                const {ouId} = item
                // 分布图数据
                allStructRequest.push(getProCraneStruct(ouId))
                allVideoListRequest.push(getProVideoList(ouId))
                allSpreadStaticRequest.push(getSpreadStaticData(ouId))
              })
              const struct = await Promise.all(allStructRequest)
              this.resolveStruct(struct)
              const videoList = await Promise.all(allVideoListRequest)
              this.resolveVideoList(videoList)
              const spreadStatic = await Promise.all(allSpreadStaticRequest)
              this.resolveSpreadStatic(spreadStatic)
            }
          } catch(e) {}
        }
      })
    },
    // 处理结构数据
    resolveStruct (result) {
      result.forEach((res) => {
        const {success, data} = res
        if (success) {
          const list = data || []
          list.forEach((item) => {
            const {projectCraneId, ...struct} = item
            this.craneStructData[projectCraneId] = struct
          })
        }
      })
    },
    // 处理视频数据
    resolveVideoList (result) {
      result.forEach((res) => {
        const {success, data} = res
        if (success) {
          const list = data || []
          list.forEach((item) => {
            const {projectCraneId, projectCraneNum, realTimeVideoList} = item
            this.craneVideoData[projectCraneId] = realTimeVideoList.map((video) => ({...video,projectCraneNum, channelStatus: 1}))
          })
        }
      })
    },
    // 处理静态数据
    resolveSpreadStatic (result) {
      const initOk = []
      const deviceIds = []
      result.forEach((res) => {
        const {success, data} = res
        if (success) {
          const {projectCraneList = []} = data
          projectCraneList.forEach((item) => {
            const {deviceId, projectCraneId, realityJibArmLength, balanceArmLength, realityCraneHeight, projectCraneNum, areaList, craneType} = item
            const hasVideo = !!this.craneVideoData[projectCraneId]
            const {groupX, groupY} = this.dataViewConfig.projectCraneMap[projectCraneId]
            const newObj = {
              craneId:projectCraneId,
              screenX: groupX,
              screenY: groupY,
              armLength: realityJibArmLength,
              balanceArmLength,
              towerHeight: realityCraneHeight,
              areaList,
              craneType: craneType === 'FlatArm' ? 0 : (craneType === 'SwingArm' ? 1 : 2),
              name: projectCraneNum,
              hasVideo
            }
            deviceIds.push(deviceId)
            initOk.push(newObj)
          })
        }
      })
      this.cranes = [...this.cranes, ...initOk]
      this.deviceIds = [...this.deviceIds, ...deviceIds]
    },
    // 获取项目信息
    getProject (projectId) {
      getProjectInfo(projectId).then(res => {
        const {data, success} = res
        if (success) {
          let obj = {
            safetyOfficer: null,
            safetyOfficerMobile: null,
            safetyDirector: null,
            safetyDirectorMobile: null
          }
          const {projectId, ouUserList, constructionCompanyName, address, projectName} = data || {}
          let hasSafetyDirector = false;
          let hasSafetyOfficer = false;
          (ouUserList || []).forEach((item) => {
            const {orgPostCode, mobile, name} = item
            if (!hasSafetyDirector && orgPostCode === 'SafetyDirector') {
              obj = {...obj, safetyDirector: name, safetyDirectorMobile: mobile}
              hasSafetyDirector = true
            }
            if (!hasSafetyOfficer && orgPostCode === 'SafetyOfficer') {
              obj = {...obj, safetyOfficer: name, safetyOfficerMobile: mobile}
              hasSafetyOfficer = true
            }
          })
          this.projectInfo = {...this.projectInfo, ...obj, name: projectName, id: projectId, constructionCompanyName, address}
          // 获取在线数据
          this.getRealData()
          // 获取行为高风险
          this.getBehavioralHighRiskDetail()
          // 获取行为低风险
          this.getBehavioralLowRiskDetail()
          // 获取机体风险
          this.getBodyRiskDetail()
          // 获取风险统计数据
          this.getRiskStat()
          // 获取高危行为风险
          this.getHighBehavioralRiskRank()
          // 获取低危行为
          this.getLowBehavioralRiskRank()
          // 获取机体风险
          this.getBodyRiskRank()
          // 轮询数据
          this.clearStatTimer()
          this.clearDetailsTimer()
          this.riskDetailsRequest()
          this.riskStatRequest()
        }
      })
    },
    // 获取在线数据
    getRealData () {
      const {id} = this.projectInfo
      getOnlineRate(id).then((res) => {
        const {data, success} = res
        if (success) {
          const {onlineTotal = 0, total = 0} = data
          const params = {
            craneTotal: total,
            online: onlineTotal
          }
          this.craneOverview = {...this.craneOverview, ...params}
        }
      })
    },
    // 获取行为风险和机体风险统计
    getRiskStat () {
      getOperationMonitorHomeStat({today, ouId: this.projectInfo.id}).then((res) => {
        const {success, data = []} = res || {}
        if (success) {
          const behavioralData = data.filter(
            (item) => item.riskType === 'behavioralRisk',
          );
          const bodyData = data.filter(
            (item) => item.riskType === 'craneBodyRisk',
          );
          const {riskNum: behaviorRiskTotal} = behavioralData[0]
          const {riskNum: bodyRiskTotal} = bodyData[0]
          this.staticsInfo = {behaviorRiskTotal, bodyRiskTotal}
        }
      })
    },
    // 获取高危风险排名
    getHighBehavioralRiskRank () {
      const params = {riskLevel: 'high', riskType: 'behavioralRisk', today, ouId: this.projectInfo.id}
      getListRiskRank(params).then((res) => {
        const {success, data = []} = res || {}
        if (success) {
          this.behaviorHighList = data
        }
      })
    },
    // 获取低危风险排名
    getLowBehavioralRiskRank () {
      const params = {riskLevel: 'low', riskType: 'behavioralRisk', today, ouId: this.projectInfo.id}
      getListRiskRank(params).then((res) => {
        const {success, data = []} = res || {}
        if (success) {
          this.behaviorLowList = data
        }
      })
    },
    // 获取机体风险排名
    getBodyRiskRank () {
      const params = {riskType: 'craneBodyRisk', today, ouId: this.projectInfo.id}
      getListRiskRank(params).then((res) => {
        const {success, data = []} = res || {}
        if (success) {
          this.bodyRiskList = data
        }
      })
    },
    // 获取高危行为风险详情
    getBehavioralHighRiskDetail () {
      const params = {dimension: 1, day: today, riskLevel: 'highRisk', ouId: this.projectInfo.id, pageSize: 50}
      getBehavioralRiskDetail(params).then((res) => {
        const {success, data = []} = res || {}
        if (success) {
          this.behaviorHighDetail = data
        }
      })
    },
    // 获取低危行为风险详情
    getBehavioralLowRiskDetail () {
      const params = {dimension: 1, day: today, riskLevel: 'lowRisk', ouId: this.projectInfo.id, pageSize: 50}
      getBehavioralRiskDetail(params).then((res) => {
        const {success, data = []} = res || {}
        if (success) {
          this.behaviorLowDetail = data
        }
      })
    },
    // 获取机体行为风险详情
    getBodyRiskDetail () {
      const params = {dimension: 1, day: today, ouId: this.projectInfo.id, pageSize: 50}
      getBodyRiskDetail(params).then((res) => {
        const {success, data = []} = res || {}
        if (success) {
          this.bodyRiskDetail = data
        }
      })
    },
    // 获取实时数据
    getRunData () {
      const deviceIds = this.deviceIds
      getSpreadRealData({deviceIds}).then(res => {
        const {data, success} = res
        if (success) {
          const newData = []
          const hasDeviceIds = []
          data.forEach((obj) => {
            const {
              deviceId,
              projectCraneId,
              angle,
              loadWeight,
              hookHeight,
              radius,
              elevationAngle,
              windSpeed,
              windScale,
              torquePercent,
              safeLoad,
              time,
              currentAlarmStatus,
              currentInfractionStatus,
              falls
            } = obj
            const newObj = {
              craneId: projectCraneId,
              dirAngle: elevationAngle,
              height: hookHeight < 0 ? 0 : hookHeight,
              radius: radius < 0 ? 0 : radius,
              rotationAngle: angle,
              loadValue: loadWeight < 0 ? 0 : loadWeight,
              windSpeed,
              windScale,
              percent: torquePercent < 0 ? 0 : torquePercent,
              safeLoad,
              recordTime: time,
              isOnline: true,
              alarm: currentAlarmStatus,
              peccancy: currentInfractionStatus,
              falls
            }
            newData.push(newObj)
            hasDeviceIds.push(deviceId)
            this.oldRunDataObj[deviceId] = newObj
          })
          const noDataIds = deviceIds.filter((item) => !hasDeviceIds.includes(item))
          noDataIds.forEach((item) => {
            const obj = this.oldRunDataObj[item]
            if (obj) {
              newData.push({...obj, isOnline: false})
            }
          })
          this.runData = newData
        }
      })
    },
    // 定时任务
    callRequest () {
      this.clearLoopTimer()
      this.clearCraneTimer()
      this.getRunData()
      this.craneObj = this.craneStructData[this.cranes[0].craneId]
      this.timerRequest()
      this.timerClickRequest()
    },
    // 实时数据轮询
    timerRequest () {
      this.loopTimer = setInterval(() => {
        this.getRunData()
        this.getRealData()
      }, 5000) // 5秒轮询
    },
    // 塔机自动轮询
    timerClickRequest () {
      this.craneTimer = setInterval(() => {
        this.switchClickCrane()
      }, 15000) // 15秒轮询塔机基础信息
    },
    // 统计自动轮询
    riskStatRequest () {
      this.riskStatTimer = setInterval(() => {
        // 获取行为风险和机体风险统计
        this.getRiskStat()
        // 获取高危风险
        this.getHighBehavioralRiskRank()
        // 获取低危风险
        this.getLowBehavioralRiskRank()
        // 获取机体风险
        this.getBodyRiskRank()
      }, 60000) // 1分钟
    },

    // 风险详情数据
    riskDetailsRequest () {
      this.riskDetailsTimer = setInterval(() => {
        // 获取行为高风险
        this.getBehavioralHighRiskDetail()
        // 获取行为低风险
        this.getBehavioralLowRiskDetail()
        // 获取机体风险
        this.getBodyRiskDetail()
      }, 30000) // 30秒
    },

    // 免登录token获取, 10分钟一次
    getShareToken () {
      this.shareTokenTimer = setInterval(() => {
        this.getProjectShareToken()
      },600000)
    },
    switchClickCrane () {
      const dataVal = Object.values(this.craneStructData)
      const len = dataVal.length
      if (this.clickIndex < len - 1) {
        this.craneObj = dataVal[this.clickIndex]
        this.clickIndex++
      } else {
        this.craneObj = dataVal[this.clickIndex]
        this.clickIndex = 0
      }
    },
    // 获取萤石云token
    getYSAccessToken () {
      getYSToken().then((res) => {
        const {success, data} = res
        if (success) {
          this.ysToken = data
        }
      })
    },
    reGetToken () {
      this.getYSAccessToken()
    },
    // 获取免登录token
    getProjectShareToken () {
      return new Promise((resolve, reject) => {
        getShareToken(this.shareTokenParams).then((res) => {
          const {success, data} = res
          if (success && data) {
            sessionStorage.setItem('authorization', `Bearer ${data}`)
          }
          resolve(success)
        })
      })
    },
    // 初始化
    init () {
      const params = this.getUrlParams()
      const {token, objectId, logo = null, appKey, nonce, signedField, signTimestamp, sign} = params
      this.logo = !logo ? (logo === null ? 'sada' : '') : logo
      if (objectId) {
        if (token) {
          sessionStorage.setItem('authorization', token)
          this.getGroupDataVConfig(objectId)
          this.getYSAccessToken()
        } else if (appKey && nonce && signedField && signTimestamp && sign) {
          const newSignedField = decodeURIComponent(signedField)
          const newSign = decodeURIComponent(sign)
          this.shareTokenParams = {objectId, appKey, nonce, signedField: newSignedField, signTimestamp, sign: newSign}
          this.getProjectShareToken().then((res) => {
            if (res) {
              this.getGroupDataVConfig(objectId)
              this.getYSAccessToken()
              this.clearShareTokenTimer()
              this.getShareToken()
            } else {
              this.$router.push('/')
            }
          })
        } else {
          this.$router.push('/')
        }
      } else {
        this.$router.push('/')
      }
    },
    // 获取url参数
    getUrlParams () {
      const params = {}
      const href = window.location.href
      const searchIndex = href.indexOf('?')
      if (searchIndex > -1) {
        const search = href.substring(searchIndex + 1)
        const paramsStr = search.split('&')
        paramsStr.forEach(res => {
          const str = res.split('=')
          params[str[0]] = str[1]
        })
      }
      return params
    },
    // 铺满全屏
    resizeFull () {
      const ratioX = window.innerWidth / 1920
      const ratioY = window.innerHeight / 1080
      $('#home-bg').css({
        transform: 'scale(' + ratioX + ', ' + ratioY + ')',
        transformOrigin: 'left top',
        backgroundSize: '100% 100%'
      })
    },
    addEvenListener () {
      const self = this
      window.onresize = function () {
        self.isScreenChange = Math.random()
        self.resizeFull()
      }
    },
    // 塔的的轮询
    clearCraneTimer () {
      if (this.craneTimer) clearInterval(this.craneTimer)
    },
    // 实时数据轮询
    clearLoopTimer () {
      if (this.loopTimer) clearInterval(this.loopTimer)
    },
    // 统计数据轮询
    clearStatTimer () {
      if (this.riskStatTimer) clearInterval(this.riskStatTimer)
    },
    // 详情数据轮询
    clearDetailsTimer () {
      if (this.riskDetailsTimer) clearInterval(this.riskDetailsTimer)
    },
    // 取消免登录轮询
    clearShareTokenTimer () {
      if (this.shareTokenTimer) clearInterval(this.shareTokenTimer)
    }

  },
  mounted () {
    this.addEvenListener()
    this.resizeFull()
    this.init()
  },

  destroyed () {
    this.clearLoopTimer()
    this.clearStatTimer()
    this.clearCraneTimer()
    this.clearDetailsTimer()
    this.clearShareTokenTimer()
  }
}
</script>

<style scoped lang="scss">
  #home-bg{
    width:1920px;
    height:1080px;
  }
  .btn-camera {
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 151px;
    height: 50px;
    left: 866px;
    top: 1001px;
    background-color: rgba(8,36,58,.73);
    border-radius: 13px;
    color: #FFFFFF;
    .text {
      margin-left: 8px;
    }
  }
  .btn-camera:hover {
    background: linear-gradient(180deg, rgba(73, 213, 243, 0.15) 0%, #49D5F3 100%);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue